import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { StoreError, StoreErrorName, titleForError, useStore } from 'zens-store'
import { Color, Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: Spacing.M,
    backgroundColor: Color.darkRed,
  },
  text: {
    color: Color.simplyWhite,
    textAlign: 'center',
  },
  info: {
    marginVertical: Spacing.M,
  },
})

const FirmwareError = () => {
  const { firmware } = useStore()
  const { error } = firmware
  const { t } = useTranslation()

  function infoForError(error?: StoreError) {
    switch (error?.name) {
      case StoreErrorName.CHARACTERISTICS_FAILED:
        return t('Did you remove the phone from the charger and turn the power off and on?')
    }
  }

  return (
    <View style={styles.container}>
      <Text style={styles.text}>{titleForError(error, t)}</Text>
      <Text style={[styles.text, styles.info]}>{infoForError(error)}</Text>
    </View>
  )
}

export default FirmwareError
